// extracted by mini-css-extract-plugin
module.exports = {"Container":"spinner_Container__8H2dA","LoadingSpinner":"spinner_LoadingSpinner__1OQsP","spinner":"spinner_spinner__2KQAF"};